import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import CompanyCertificationContainer from "@/screens/Companies/edit/components/certification/containers/CompanyCertificationContainer"

export const Route: AnyRoute = createFileRoute("/app/companies/$companyId/edit/_layout/certification")({
  component: CompanyCertificationContainer,
})
